import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lastfm-artist-review"
// Handles Last.fm artist review form interactions
export default class extends Controller {
  // Handle radio button changes to show/hide relevant fields
  handleCorrectRadio(event) {
    const radio = event.target

    // Only process if it's a correct[] radio button
    if (!radio.type === 'radio' || !radio.name.match(/^correct\[\d+\]$/)) {
      return
    }

    const tr = radio.closest('tr')
    const match = radio.name.match(/^correct\[(\d+)\]$/)
    if (!match) return

    const lastFmArtistId = parseInt(match[1])
    const altUrlField = tr.querySelector(`input[name="alt_url[${lastFmArtistId}]"]`)
    const fixSpellingDiv = tr.querySelector('div.fix-spelling-div')

    if (!altUrlField || !fixSpellingDiv) return

    if (radio.value === '1') {
      // "Yes" selected - show fix spelling checkbox, hide URL field
      fixSpellingDiv.classList.remove('d-none')
      altUrlField.classList.add('d-none')
      altUrlField.disabled = true
    } else {
      // "No" selected - hide fix spelling checkbox, show URL field
      fixSpellingDiv.classList.add('d-none')
      altUrlField.classList.remove('d-none')
      altUrlField.disabled = false
    }
  }

  // Check all radio buttons that have data-auto-check="1"
  checkAllIdenticalNames(event) {
    event.preventDefault()

    document.querySelectorAll('input[type=radio][data-auto-check="1"]').forEach(el => {
      el.checked = true

      // Trigger the change to update visibility of related fields
      const changeEvent = new Event('click', { bubbles: true })
      el.dispatchEvent(changeEvent)
    })
  }
}
